import { isUndefined } from 'lodash';
import { useCallback } from 'react';

import { useTrackSelectedComment } from '@air/analytics';
import { type Discussion } from '@air/api/types';

import { usePDFOutlineContext } from '~/components/AssetModalV2/Content/Footer/contexts/PDFOutlineContext';
import { QueryParamNames, type QueryType } from '~/constants/search';
import { setQueryParams } from '~/utils/PathUtils';

export type OnPDFCommentClickProps = {
  onSwitchVersion: (query?: QueryType) => void;
  discussionId: Discussion['id'];
  hasAnnotation: boolean;
  pageNumber?: number;
};

export const usePDFCommentClick = () => {
  const { trackSelectedComment } = useTrackSelectedComment();
  const { changePage } = usePDFOutlineContext();

  const onPDFCommentClick = useCallback(
    async ({ onSwitchVersion, discussionId, hasAnnotation, pageNumber }: OnPDFCommentClickProps) => {
      const activeDiscussionId = new URLSearchParams(window.location.search).get(QueryParamNames.discussionId);
      const isTogglingOff = activeDiscussionId === discussionId;

      const query: QueryType = {
        [QueryParamNames.discussionId]: isTogglingOff ? null : [discussionId],
        [QueryParamNames.page]: pageNumber,
      };

      await setQueryParams(query, 'replace');
      onSwitchVersion(query);

      if (!isUndefined(pageNumber)) {
        changePage(pageNumber);
      }

      trackSelectedComment({
        location: 'discussions tab',
        has_annotation: hasAnnotation,
        has_timestamp: !isUndefined(pageNumber),
      });
    },
    [changePage, trackSelectedComment],
  );

  return { onPDFCommentClick };
};
